export function volumeBreakSavingsPct(
  basePriceMinor: number,
  tierPriceMinor: number,
): number {
  if (basePriceMinor <= 0) return 0;
  const raw = ((basePriceMinor - tierPriceMinor) / basePriceMinor) * 100;
  return Math.floor(raw + 0.5); // HMRC half-up
}

export function nearestValidQty(
  given: number,
  moq: number,
  increment: number,
): [number, number] {
  if (increment <= 0) return [moq, moq]; // degenerate increment — fall back to MOQ
  if (given < moq) return [moq, moq];
  const floor = Math.max(Math.floor(given / increment) * increment, moq);
  const ceil = Math.max(Math.ceil(given / increment) * increment, moq);
  return [floor, ceil];
}

export interface VolumeBreakTier {
  min_quantity: number;
  unit_price_minor: number;
}

export function resolveActiveTier<T extends VolumeBreakTier>(
  breaks: ReadonlyArray<T>,
  quantity: number,
): T | null {
  let active: T | null = null;
  for (const b of breaks) {
    if (b.min_quantity <= quantity) {
      if (active === null || b.min_quantity > active.min_quantity) {
        active = b;
      }
    }
  }
  return active;
}
